export default __webpack_public_path__ + "static/media/money.3e391cb1.svg";